import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import $t from 'translation';
import LogoImg from 'assets/images/ethelo.png';

const LogoSection = ({ url = '/' }) => (
  <Link to={url} underline="none" title="logo">
    <img
      src={LogoImg}
      alt={$t('header.logo.title')}
      width={130}
      loading="lazy"
    />
  </Link>
);

LogoSection.propTypes = {
  url: PropTypes.string,
};

export default LogoSection;
